import PropTypes from 'prop-types';
import Feature from './Feature';

const FeatureComponent = ({ name, render }) => {
  if (Feature.isEnabled(name)) {
    return render();
  }
  return null;
};

FeatureComponent.propTypes = {
  name: PropTypes.string,
  render: PropTypes.func.isRequired
};

export default FeatureComponent;



// WEBPACK FOOTER //
// ./src/components/atoms/Feature/FeatureComponent.js